import React from 'react';
import Link from '../components/Link';
import Line from '../components/Line';
import Image from '../components/Image';
import CommissionText from '../components/CommissionText';
import {
    bet365 as bet365Urls,
    common as commonUrls,
} from '../urlConstants';
import '../styles.scss';

const Bet365 = () => (
    <div className="bs-gamblingCompliance">
        <div className="bs-gamblingCompliance__message">
            <Line>
                Best Odds Guaranteed. Take a price and if the starting price is bigger,
                bet365 pays at the bigger odds.&nbsp;
                <Link
                    href="https://extra.bet365.com/promotions/en/horse-racing/best-odds-guaranteed"
                    text="Bet restrictions and T&Cs apply"
                />. New and eligible customers only.</Line>
            &nbsp;
            <Line>
                Bets are accepted in accordance with the operator&#39;s&nbsp;
                <Link href={bet365Urls.rules} text="rules" />&nbsp;
                and&nbsp;
                <Link
                    href={bet365Urls.termsAndConditions}
                    text="terms and conditions"
                />.&nbsp;
                Hillside (UK Sports) ENC is licensed and regulated by the British
                Gambling Commissioner (Account Number 55148). Registered Office Hillside
                (UK Sports) ENC (Registration Number P1892), Unit 1.1, First Floor,
                Waterport Place, 2 Europort Avenue, Gibraltar.
            </Line>
            &nbsp;
            <CommissionText />
        </div>
        <div className="bs-gamblingCompliance__images">
            <Image imageName="underageRed" />
            <Image href={commonUrls.gamaware} imageName="gamaware" />
            <Image href={commonUrls.gamcare} imageName="gamcare" />
            <Image href={commonUrls.gamtherapy} imageName="gamtherapyTransparent" />
            <Image href={commonUrls.raig} imageName="raig" />
        </div>
    </div>
);

export default Bet365;



// WEBPACK FOOTER //
// /src/js/common/gamblingCompliance/Bet365/fullGamblingCompliance.jsx